// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17C-8","rightAdornment":"Header_rightAdornment__3pyQq"};